import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-templatebase',
  templateUrl: './templatebase.component.html',
  styleUrls: ['./templatebase.component.css']
})
export class TemplatebaseComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
